var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { designSchema } from '../../../../../../../contexts/designs/utils';
import { headerFooterMixin } from '../../styles';
export var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom-width: 1px;\n  font-size: 22px;\n\n  ", ";\n"], ["\n  border-bottom-width: 1px;\n  font-size: 22px;\n\n  ", ";\n"])), headerFooterMixin);
export var Grantor = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-transform: uppercase;\n"], ["\n  text-transform: uppercase;\n"])));
export var StatusText = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), designSchema);
export var StatusValue = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
export var StatusWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  min-width: 156px;\n"], ["\n  min-width: 156px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
